import React from 'react';

import Image from 'next/image';

import { BENEFIT } from '@/utils/assets';
import componentsId from '@/utils/componentsId';

import styles from './BenefitsHero.module.scss';
import Section from '@/components/Section';

const BenefitsHero = () => {
  return (
    <Section id={componentsId.benefits.pyme.section} customClass={styles.benefits}>
      <div className={styles.container}>
        <div className={styles.text_container}>
          <Image
            className={styles.heart}
            height={80}
            width={80}
            alt=""
            src={BENEFIT.ICON_HEARTH}
          />
          <Image
            className={styles.medicine}
            height={104}
            width={104}
            alt=""
            src={BENEFIT.ICON_MEDICINE}
          />
          <Image
            className={styles.snake}
            height={60}
            width={60}
            alt=""
            src={BENEFIT.ICON_SNAKE}
          />
          <Image
            className={styles.tenis}
            height={104}
            width={104}
            alt=""
            src={BENEFIT.ICON_TENIS}
          />
          <div className={styles.title}>
            <span>Beneficios</span> que protegen la salud y mejoran la calidad de vida de tu equipo
          </div>
          <div className={styles.title_mobile}>
            <span>Beneficios</span> que protegen la salud y la calidad de vida de tu equipo
          </div>
          <div className={styles.body}>
            Te ofrecemos atención médica, hospitalaria, descuentos en medicamentos y convenios para
            cuidar tu salud.
          </div>
          <div className={styles.footer}>
            Contratación e incorporación 100% digital, rápida y simple.
          </div>
        </div>
      </div>
    </Section>
  );
};

export default BenefitsHero;
